import type React from 'react';

import { Breadcrumb, Breadcrumbs } from '@vlabs/uikit';
import { routes } from '@vlapps/clementine/src/app/navigation/routes';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

function ImagePageChecksBreadcrumbs(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Breadcrumbs>
      <Breadcrumb
        caption={t('checks:check page title')}
        href={generatePath(routes.checks.read)}
      />
      <Breadcrumb caption={t('checks:image checks.page.breadcrumbs.current')} />
    </Breadcrumbs>
  );
}

export { ImagePageChecksBreadcrumbs };
